import { create } from 'zustand';
import { DEVICE_ENUM, PREVIEW_SIZE_MAP } from './constants';

export interface DimensionSlice {
    currentDimension: DEVICE_ENUM;
    previewSize: (typeof PREVIEW_SIZE_MAP)[keyof typeof PREVIEW_SIZE_MAP];
    setCurrentDimension: (dimension: DEVICE_ENUM) => void;
}

export interface DimensionState {
    currentDimension: DEVICE_ENUM;
    previewSize: (typeof PREVIEW_SIZE_MAP)[keyof typeof PREVIEW_SIZE_MAP];
}

export interface DimensionActions {
    getDimension: () => DEVICE_ENUM;
    setCurrentDimension: (dimension: DEVICE_ENUM) => void;
}

export const useDimensionStore = create<DimensionState & DimensionActions>(
    (set, get) => ({
        currentDimension: DEVICE_ENUM.DESKTOP,
        previewSize: PREVIEW_SIZE_MAP[DEVICE_ENUM.DESKTOP],
        getDimension: () => get().currentDimension,
        setCurrentDimension: (dimension: DEVICE_ENUM) => {
            const dimensionSize = PREVIEW_SIZE_MAP[dimension];

            return set({
                currentDimension: dimension,
                previewSize: dimensionSize,
            });
        },
    })
);
